import React from 'react';
import QuestionRadioGroup from '../../atoms/QuestionRadioGroup';
import QuestionCheckboxGroup from '../../atoms/QuestionCheckboxGroup';
import QuestionOptionButton from '../../atoms/QuestionOptionButton';

const qgLookupTable = {
    radio: ({
        id,
        metadata,
        answers,
        updateCallback,
        dynamicErrorCount,
        errorMessages,
        inputValue,
    }) => (
        <QuestionRadioGroup
            id={id}
            metadata={metadata}
            answers={answers}
            updateCallback={updateCallback}
            dynamicErrorCount={dynamicErrorCount}
            errorMessages={errorMessages}
            inputValue={inputValue}
        />
    ),
    checkbox: ({
        id,
        metadata,
        answers,
        updateCallback,
        dynamicErrorCount,
        errorMessages,
    }) => (
        <QuestionCheckboxGroup
            id={id}
            metadata={metadata}
            answers={answers}
            updateCallback={updateCallback}
            dynamicErrorCount={dynamicErrorCount}
            errorMessages={errorMessages}
        />
    ),
    optionButton: ({
        id,
        metadata,
        answers,
        updateCallback,
        dynamicErrorCount,
        errorMessages,
        inputValue,
    }) => (
        <QuestionOptionButton
            id={id}
            metadata={metadata}
            answers={answers}
            updateCallback={updateCallback}
            dynamicErrorCount={dynamicErrorCount}
            errorMessages={errorMessages}
            inputValue={inputValue[0] ? inputValue[0] : ''}
        />
    ),
};

function QuestionGroup({
    fullQuestion,
    questionCallback,
    dynamicErrorCount,
    errorMessages,
    inputValue,
}) {
    const { id, metaData, answers } = fullQuestion;
    const GeneratedGroup = qgLookupTable[metaData.questionType];

    return (
        <>
            <div
                className="question--radio-group"
                id={`component-${id}`}
            >
                <GeneratedGroup
                    key={id}
                    id={id}
                    metadata={metaData}
                    answers={answers}
                    updateCallback={questionCallback}
                    dynamicErrorCount={dynamicErrorCount}
                    errorMessages={errorMessages}
                    inputValue={inputValue}
                />
            </div>
        </>
    );
}

export default QuestionGroup;
